import type { AccountingPeriodState } from '@chukua/common';

export type PeriodActionKind = 'close' | 'lock' | 'unlock';

export interface PeriodPermissions {
  canManage: boolean;
  canLock: boolean;
  canUnlock: boolean;
}

/**
 * The one move a period offers from where it stands, if the user may make it: open → closing → locked, and locked back
 * with a reason. Hiding the rest is UX only; the server decides (`nextPeriodState` in the API).
 */
export function availablePeriodAction(state: AccountingPeriodState, permissions: PeriodPermissions): PeriodActionKind | null {
  if (state === 'open') return permissions.canManage ? 'close' : null;
  if (state === 'closing') return permissions.canLock ? 'lock' : null;
  return permissions.canUnlock ? 'unlock' : null;
}

export const PERIOD_ACTION_LABELS: Record<PeriodActionKind, string> = { close: 'Start close', lock: 'Lock', unlock: 'Unlock' };

export const PERIOD_STATE_LABELS: Record<AccountingPeriodState, string> = { open: 'Open', closing: 'Closing', locked: 'Locked' };

/** Tag colours are Ant's preset names, which the brand theme maps onto the palette. */
export const PERIOD_STATE_COLORS: Record<AccountingPeriodState, string> = { open: 'success', closing: 'warning', locked: 'default' };
